<nz-layout>
  @if (isLoggedIn) {
    <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="expander" [nzTheme]="theme" nzWidth="250px"
      [nzCollapsedWidth]="71" [class.collapsed]="isCollapsed">
      <ul nz-menu [nzTheme]="theme" nzMode="inline" class="menu-container">
        <ng-template #expander>
          <div class="trigger-menu"
            [class.expanded]="!isCollapsed">
            @if (!isCollapsed) {
              <div class="logo-container">
                <img src="assets/Diazar.svg">
                <span class="logo-title">Diazar Control</span>
              </div>
            }
            <span nz-icon
                  class="expand-icon"
                  [nzType]="isCollapsed ? 'right-circle' : 'left-circle'"
                  style="color: #0D6EFD"
            ></span>
          </div>
        </ng-template>
        @for (item of menuItems; track item.title) {
          @if (isSubmenu(item)) {
            <li nz-submenu [nzTitle]="item.title" [nzIcon]="hasIcon(item)">
              <ul>
                @for (child of item.children; track child.title) {
                  @if (isSubmenu(child)) {
                    <li nz-submenu [nzTitle]="child.title"
                      [nzIcon]="hasIcon(child)">
                      <ul>
                        @for (subchild of child.children; track subchild.title) {
                          <li nz-menu-item [nzDisabled]="!child.hasAccess"
                            [nzSelected]="isRouteSelected(subchild.to)"
                            [nzTooltipTrigger]="!child.hasAccess ? 'hover' : null"
                            nz-tooltip nzTooltipTitle="No tienes acceso a esta sección"
                            (click)="child.hasAccess ? redirectTo(subchild.to) : null">
                            @if (subchild.icon) {
                              <i nz-icon [nzType]="subchild.icon"></i>
                            }
                            <span>{{ subchild.title + 'test' }}</span>
                          </li>
                        }
                      </ul>
                    </li>
                  } @else {
                    <li nz-menu-item [nzDisabled]="!child.hasAccess"
                      [nzSelected]="isRouteSelected(child.to)"
                      [nzTooltipTrigger]="!child.hasAccess ? 'hover' : null"
                      nz-tooltip nzTooltipTitle="No tienes acceso a esta sección"
                      (click)="child.hasAccess ? redirectTo(child.to) : null">
                      @if (child.icon) {
                        <i nz-icon [nzType]="child.icon"></i>
                      }
                      <span>{{ child.title }}</span>
                    </li>
                  }
                }
              </ul>
            </li>
          } @else {
            <li nz-menu-item (click)="redirectTo(item.to)" [nzSelected]="isRouteSelected(item.to)">
              @if (item.icon) {
                <i nz-icon [nzType]="item.icon"></i>
              }
              <span>{{ item.title }}</span>
            </li>
          }
        }
      </ul>
    </nz-sider>
  }
  <nz-layout class="content-container">
    @if (isLoggedIn) {
      <nz-header [class.collapsed]="isCollapsed">
        <app-topbar [isCollapsed]="isCollapsed"
          (toggleCollapse)="handleToggle()" (goToUserProfile)="onGoToUserProfile()"></app-topbar>
      </nz-header>
    }
    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
    <nz-footer>Diazar | Control Empowerment ©{{currentYear || '2025'}}</nz-footer>
  </nz-layout>
</nz-layout>
